import type { ReactElement } from 'react'

import { ForecastTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
// import { AnotationList } from '@/components/enlayouts/Ir/AnotationList'


import { useMpocketScript } from '@/hooks/useMpocketScript'


export const ForecastPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-financial-forecast_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-financial-forecast_en.js')
/* const anotationlist: string[] = [
    'Net income per share for FY2023 (Results) is calculated based on the average number of shares outstanding during the period.',
    'Net income per share for FY2024 (Forecast) is calculated based on the expected average number of shares during the period, including the number of shares planned to be publicly offered (21,200,000 shares) and does not take into account the number of new shares to be allocated to third parties (up to 3,427,900 shares) in connection with the secondary offering by way of over-allotment.',
    'Although a 200-for-1 stock split of shares of common stock was conducted on January 31, 2023, net income per share is calculated on the assumption that the stock split was conducted at the beginning of the fiscal year ended June 30, 2023.',
  ] */

  return (
    <Layout>
      <SectionTitle
        enTitleText="Consolidated Forecast"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 30 }} />
      <ForecastTable />
      <Spacer h={{ sp: 50, pc: 80 }} />
      {/* <AnotationList listItem={anotationlist} /> */}
    </Layout>
  )
}

ForecastPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Financial Information', path: '/en/ir/financial/' },
    { name: 'Consolidated Forecast', path: '' },
  ]

  return (
    <>
      <Head
        title="Consolidated Forecast"
        description="The consolidated performance forecast for our group."
        ogp={{ url: 'en/ir/financial/forecast' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
